import { useContext, useEffect, useState } from 'react';
import { useFormatText } from '../../hooks/useFormatText';
import { LangContext } from '../../context/LangContext';
import SelectLang from '../../components/SelectLang';

import "./style.css";
import Slider from '../../components/Slider';

function Planning() {
    const formatText = useFormatText();
    const [formData, setFormData] = useState(null);
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        const fetchPlanningData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/planning/get`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);

            setFormData({
                descrip_fr: res.descrip_fr || '',
                descrip_en: res.descrip_en || '',
                images: res.images || [],
            });
        }
        fetchPlanningData();
    }, []);

    return formData && (
        <div className='page page_planning'>
            <SelectLang />

            <section className="sect_presentation">
                <Slider images={formData.images} />

                <div className="description">
                    <span className='title_page'>
                        - <span>Planning</span> -
                    </span>

                    <div className="textarea">
                        <span className="label">{translations.detail_and_descrip} :</span>
                        <p className="value">{formatText(formData[`descrip_${language}`])}</p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Planning;